export default [
  {
    path: 'primary-area-of-construction',
    meta: {
      title: 'Primary Area of Construction',
      auth: ['Admin', 'Super Admin'],
      hidden: false
    },
    component: () => import('./pages/index'),
    redirect: 'primary-area-of-construction/list',
    children: [
      {
        path: 'list',
        meta: {
          auth: ['Admin', 'Super Admin'],
          title: 'List',
          resource: 'primaryAreaOfConstruction',
          icon: 'playlist_add_check',
          hidden: false
        },
        component: () => import('./pages/list')
      },
      {
        path: 'edit/:id',
        meta: {
          auth: ['Admin', 'Super Admin'],
          title: 'Edit',
          resource: 'primaryAreaOfConstruction',
          icon: 'mode_edit',
          hidden: true
        },
        component: () => import('./pages/edit')
      },
      {
        path: 'add',
        meta: {
          auth: ['Admin', 'Super Admin'],
          title: 'Add',
          resource: 'primaryAreaOfConstruction',
          icon: 'add_circle_outline',
          hidden: false
        },
        component: () => import('./pages/add')
      }
    ]
  }
]
